import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4F6A532E-58ED-4CB5-9BBB-9E77C128D536
 * name equalizer
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/equalizer.svg
 * tags
 * - Audio 
 */
export const EqualizerIcon = createSvgIcon(<><path d="M10,20H14V4H10V20M4,20H8V12H4V20M16,9V20H20V9H16Z" /></>, 'EqualizerIcon');
export default EqualizerIcon